import React, { Fragment } from "react";
import { func, string, bool, shape } from "prop-types";
import moment from "moment";
import { monthNames, getDurationBetween } from "../../../helpers";
import * as style from "./styles.module.scss";

const WorkHistoryCard = ({
  workHistory: {
    id,
    title = "",
    companyName,
    fromMonth = "",
    fromYear = "",
    toMonth = "",
    toYear = "",
    currentlyWorkHere = false,
    description = "",
  },
  includeButtons,
  onEdit,
  onRemove,
}) => {
  const thisMonth = moment().format("M");
  const thisYear = moment().format("YYYY");
  const toDateDisplay = currentlyWorkHere
    ? "present"
    : `${monthNames[toMonth].substring(0, 3)} ${toYear}`;
  return (
    <div className={`justify-content-center mb-2 ${style.workCard}`}>
      <div className={`p-1 ${style.workCard__inner}`}>
        <div className="d-flex justify-content-between align-items-center">
          <h3 className={`m-0 ${style.workCard__title}`}>{title}</h3>
          <h6 className={`${style.workCard__duration} m-0`}>
            {monthNames[fromMonth].substring(0, 3)} {fromYear} - {toDateDisplay}
          </h6>
        </div>

        <div className="d-flex justify-content-between align-items-center">
          <h6 className={`m-0 ${style.workCard__subtitle}`}>{companyName}</h6>
          {currentlyWorkHere ? (
            <p className={`${style.workCard__duration} m-0`}>
              {getDurationBetween([fromYear, fromMonth], [thisYear, thisMonth])}
            </p>
          ) : (
            <p className={`${style.workCard__duration} m-0`}>
              {getDurationBetween([fromYear, fromMonth], [toYear, toMonth])}
            </p>
          )}
        </div>

        <p className={`mt-1 mb-0 ${style.workCard__description}`}>
          {description}
        </p>
        {includeButtons && (
          <Fragment>
            <button
              className="btn-plain text-primary p-0"
              onClick={() => onEdit(id)}
            >
              Edit
            </button>
            <button
              className="btn-plain text-primary p-0 float-right"
              onClick={() => onRemove(id)}
            >
              Remove
            </button>
          </Fragment>
        )}
      </div>
    </div>
  );
};

WorkHistoryCard.propTypes = {
  workHistory: shape({
    id: string.isRequired,
    title: string,
    companyName: string,
    fromMonth: string,
    fromYear: string,
    toMonth: string,
    toYear: string,
    currentlyWorkHere: bool,
    description: string,
  }).isRequired,
  includeButtons: bool.isRequired,
  onEdit: func.isRequired,
  onRemove: func.isRequired,
};

export default WorkHistoryCard;
